import React, { useState, useEffect } from 'react';
import './BigBanners.css';

const banners = [
  {
    image: require('../../../assets/banner1.jpg'),
    eyebrow: 'Marketplace',
    title: 'Todo el mundo cannábico, en un solo lugar.',
    description: 'Aceites de CBD, cultivo y accesorios. Le comprás directo a la tienda, sin intermediarios.',
  },
  {
    image: require('../../../assets/banner2.jpg'),
    eyebrow: 'Tiendas',
    title: 'Los growshops que ya conocés, y los que te faltan conocer.',
    description: 'Cada tienda con su catálogo, sus precios y su forma de enviar.',
  },
  {
    image: require('../../../assets/banner3.jpeg'),
    eyebrow: 'Comunidad',
    title: 'Hecho acá, para la escena de acá.',
    description: 'Un lugar para que las marcas argentinas lleguen a todo el país.',
  },
];

const Chevron = ({ dir }) => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d={dir === 'left' ? 'M15 5 8 12l7 7' : 'M9 5l7 7-7 7'} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const BigBanners = () => {
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentBannerIndex((prevIndex) => (prevIndex + 1) % banners.length);
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  const changeBanner = (direction) => {
    if (direction === 'next') {
      setCurrentBannerIndex((prevIndex) => (prevIndex + 1) % banners.length);
    } else if (direction === 'prev') {
      setCurrentBannerIndex(
        (prevIndex) => (prevIndex - 1 + banners.length) % banners.length
      );
    }
  };

  const currentBanner = banners[currentBannerIndex];

  return (
    <div className="big-banners-container">
      <img className="banner-image" src={currentBanner.image} alt={`Banner ${currentBannerIndex + 1}`} />
      <div className="big-banner-overlay" />
      <div className="big-banner-content">
        <div className="big-banner-copy">
          <span className="big-banner-eyebrow">{currentBanner.eyebrow}</span>
          <h1>{currentBanner.title}</h1>
          <p>{currentBanner.description}</p>
          <div className="big-banner-actions">
            <a href="/productos" className="big-banner-primary-action">Ver productos</a>
            <a href="/tiendas" className="big-banner-secondary-action">Explorar tiendas</a>
          </div>
        </div>
        <div className="big-banner-benefits">
          <div>
            <strong>Comprás directo</strong>
            <span>Hablás con la tienda que vende, sin intermediarios.</span>
          </div>
          <div>
            <strong>Envíos a todo el país</strong>
            <span>Cada tienda define cómo y adónde despacha.</span>
          </div>
          <div>
            <strong>Todo en un solo lugar</strong>
            <span>Cultivo, CBD y accesorios sin saltar de web en web.</span>
          </div>
        </div>
      </div>
      <button type="button" className="arrow left-arrow" onClick={() => changeBanner('prev')} aria-label="Banner anterior">
        <Chevron dir="left" />
      </button>
      <button type="button" className="arrow right-arrow" onClick={() => changeBanner('next')} aria-label="Banner siguiente">
        <Chevron dir="right" />
      </button>
      <div className="big-banner-dots">
        {banners.map((banner, index) => (
          <button
            key={banner.title}
            type="button"
            className={`big-banner-dot ${index === currentBannerIndex ? 'active' : ''}`}
            onClick={() => setCurrentBannerIndex(index)}
            aria-label={`Ir al banner ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default BigBanners;
